import { Attribute, Component, HostBinding, Input, Optional } from '@angular/core';

@Component({
    standalone: false,
    selector: '[unity-nav]',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./unity-nav.component.scss'],
})
export class UnityNavComponent {};